<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class=""
      >{{item.ativo == 'S' ? 'Desativar' : 'Ativar' }} tipo tarifário</mat-card-title
    >
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-5 container mx-auto">
    <mat-card class="card-style px-4 py-6 mt-3">
      <div class="flex flex-col gap-2 mt-4 mb-2">
        <div class="text-lg text-center">
          Deseja <strong>{{item.ativo == 'S' ? 'desativar' : 'ativar' }}</strong> o seguinte tipo de tarifário
          <strong>{{item.descricao }}</strong>?
        </div>
        @if(item.ativo == 'S'){
        <div class="text-lg mt-3 text-center" style="color: #9e0b0b">
          Lembrando que <strong>TODOS</strong> os tarifário vinculados a
          ao tipo de tarifário <strong>{{item.descricao }}</strong> serão destavados.
        </div>
        }
      </div>
    </mat-card>
    @if (!loading) {
      <div class="flex justify-center gap-4 py-2 px-6 mt-6 items-center">
        <button
          mat-flat-button
          class="btn-tg w-2/5"
          [disabled]="loading"
          (click)="toggleStatusTypeTariff()"
        >
          @if (loading) {
            <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
          } @else {
            {{item.ativo == 'S' ? 'Desativar' : 'Ativar' }} tipo tarifário
          }
        </button>
        <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
      </div>
    } @else {
      <mat-divider></mat-divider>
      <div class="flex flex-col items-center gap-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</mat-card>
